module.exports = __webpack_public_path__ + "assets/img/tip.b4927c22.png";